export const WS_HANDLER_COMPONENT_NAME = 'commonDataListEventsReducer';
